/* L'Établi — un kit KitCreator est indivisible (Nathan, 03/10/2026).
   Si un de ses 3 produits est retiré du panier (ou si sa quantité change),
   les autres produits du kit sont retirés aussi, puis le panier est rechargé.
   Le paiement ne donne de toute façon ni remise ni port offert à un kit incomplet. */
(function () {
  'use strict';
  if (window.__letabliKitPanier) return;
  window.__letabliKitPanier = true;
  var MARK = '_letabli_kit';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var busy = false;

  function notice() {
    var flag = null;
    try { flag = sessionStorage.getItem('letabli-kit-retire'); sessionStorage.removeItem('letabli-kit-retire'); } catch (e) {}
    if (!flag) return;
    var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var box = document.createElement('div');
    box.setAttribute('role', 'status');
    box.textContent = en ? 'The kit has been removed: its 3 products go together.'
                         : 'Le kit a été retiré : ses 3 produits vont ensemble.';
    box.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;' +
      'background:#2f1027;color:#fff;padding:12px 18px;border-radius:999px;font:600 14px/1.3 inherit;' +
      'box-shadow:0 10px 30px rgba(0,0,0,.25);max-width:calc(100% - 32px);text-align:center';
    document.body.appendChild(box);
    setTimeout(function () { box.remove(); }, 6000);
  }

  function check() {
    if (busy) return;
    busy = true;
    nativeFetch(root + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var kit = (cart.items || []).filter(function (i) { return i.properties && i.properties[MARK]; });
        if (!kit.length) return;
        var tokens = {}, variants = {};
        kit.forEach(function (i) { tokens[i.properties[MARK]] = 1; variants[i.variant_id] = 1; });
        var complete = kit.length === 3 && Object.keys(tokens).length === 1 &&
          Object.keys(variants).length === 3 && kit.every(function (i) { return i.quantity === 1; });
        if (complete) return;
        var updates = {};
        kit.forEach(function (i) { updates[i.key] = 0; });
        return nativeFetch(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          try { sessionStorage.setItem('letabli-kit-retire', '1'); } catch (e) {}
          window.location.reload();
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  // Every cart change made by the theme (remove button, quantity) goes through fetch.
  window.fetch = function () {
    var args = arguments;
    return nativeFetch.apply(window, args).then(function (response) {
      try {
        var url = String(args[0] && args[0].url ? args[0].url : args[0]);
        if (/\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) setTimeout(check, 60);
      } catch (e) {}
      return response;
    });
  };

  function start() { notice(); check(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
